import axios from 'axios';
import { toast } from 'react-toastify';
import { API } from '../config/api';

// Create an axios instance with the base URL
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Add request interceptor to include auth token if available
apiClient.interceptors.request.use(
  config => {
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    if (storedAuthState) {
      const parsedAuthState = JSON.parse(storedAuthState);
      if (parsedAuthState && parsedAuthState.token) {
        config.headers['Authorization'] = `Bearer ${parsedAuthState.token}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors (unauthorized/expired token)
apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized
      const storedAuthState = sessionStorage.getItem("authLocalstorage");
      if (storedAuthState) {
        // Afficher l'alerte de session expirée
        toast.error("⏰ Votre session a expiré. Veuillez vous reconnecter.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        
        // Nettoyer la session
        sessionStorage.removeItem('authLocalstorage');
        
        // Rediriger vers la page de connexion après un court délai
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

// Export the API client as default
export { API };
export default apiClient;
